import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const AdvancedProductBkg1Svg = () => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='100%'
    height='282'
    viewBox='0 0 761 282'
    fill='none'
  >
    <path
      d='M0.476562 10C0.476562 4.47716 4.95372 0 10.4766 0H750.477C755.999 0 760.477 4.47715 760.477 10V122.571L0.476562 281.173V10Z'
      fill='url(#paint0_linear_368_2018)'
    />
    <defs>
      <linearGradient
        id='paint0_linear_368_2018'
        x1='0.476563'
        y1='0'
        x2='560.983'
        y2='503.329'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#EDDDFC' />
        <stop offset='1' stopColor='#FFECD9' />
      </linearGradient>
    </defs>
  </svg>
);

export const AdvancedProductBkgIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={AdvancedProductBkg1Svg} {...props} />
);
